module.exports = __webpack_public_path__ + "img/logo_bbb.7f22fbd0.svg";